import { module as Module } from 'modujs'
import { body } from '../utils/environment.js'

export default class extends Module {
  constructor(m) {
    super(m)
  }

  init() {
    this.initTimeout()
  }

  initTimeout() {
    this.el.style.pointerEvents = 'none'

    setTimeout(() => {
      this.el.style.pointerEvents = 'auto'
    }, 3500)
  }

  update() {
    this.initTimeout()
  }

  destroy() {
    this.el.style.pointerEvents = 'none'
  }
}
